import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class BreadCrumb extends React.PureComponent {
    static propTypes = {
        headerData: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const {
            headerData: { breadCrumbdata },
        } = this.props;

        return (
            <div className={styles.speNav}>
                {breadCrumbdata.slice(1).map((item, index) => (
                    <span key={index}>
                        <a href={item.url} target="_blank">
                            {item.title}
                        </a>
                        {' > '}
                    </span>
                ))}
                <span>正文</span>
            </div>
        );
    }
}

export default errorBoundary(BreadCrumb);
